import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AskForLangComponent} from "./ask-for-lang.component";
import {MatButtonModule} from "@angular/material/button";
import {FuseCardModule} from "../../../@fuse/components/card";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";



@NgModule({
    declarations: [AskForLangComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        FuseCardModule,
        MatProgressSpinnerModule
    ],
  exports: [
    AskForLangComponent
  ]
})
export class AskForLangModule { }
